import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-single-line-field',
  templateUrl: './single-line-field.component.html',
  styleUrls: ['./single-line-field.component.scss']
})
export class SingleLineFieldComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
